export const alertConstants = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  CLEAR: 'clear'
};
